// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"56ba3309","250":"a352595d","453":"f7380716","732":"1d6a9b69","968":"f314dbd2","977":"1da224d9"}[chunkId] + ".chunk.js";
};